








































// @ is an alias to /src
import { Vue, Component } from 'vue-property-decorator';
import PermUtil from '@/model/PermUtil';

@Component({
  components: {
  },
})
export default class Group extends Vue {
  mounted() {
    if (this.org.groups.length) {
      this.$store.dispatch('bindSubOrganizations', this.org.groups);
    }
  }

  get org() {
    return this.$store.state.orgObj;
  }

  get Orgs() {
    return this.$store.state.subOrganizations;
  }
  // eslint-disable-next-line
  get showRegister() {
    return PermUtil.canCreateOrganization();
  }

  orgComp(org: any) {
    // this.$store.commit('setOrg', org);
    this.$store.dispatch('bindOrgObj', org.id);
    this.$router.push(`/organization/${org.id}`);
  }
}
